import React from 'react'
import { UserAvatar } from 'h-commons'
import RowCells from './RowCells'
const Rows = ({index:i, style, data:rowData}) => {
    const { data, 
        rowClassName, 
        cellClassName, 
        noAvatar, 
        disableSelect, 
        onToggleSelected,
        avatar,
        classes,
        columns,
        isChecked
    } = rowData

    const d = data[i];
    const disabledClass = (d.disableSelect && !d.isSourceUserForSm) ? 'h-disabled' : '';

    return (
            <div style={style} className={rowClassName} key={`user-table-row-${i}`}>
                <div className={`${cellClassName} ${disabledClass}`}>
                    {!disableSelect && <label className="md-checkbox">
                        <input
                            type="checkbox"
                            checked={isChecked(i)}
                            disabled={d.disableSelect}
                            onChange={(e) => onToggleSelected(e, data, d, i)}
                        />
                        <span />
                    </label>
                    }
                    {!noAvatar &&
                        <UserAvatar
                            name={d[avatar.nameKey]}
                            avatarUrl={d[avatar.urlKey]}
                            avatarColor={d[avatar.colorKey]}
                            additionalClass={classes.avatar}
                        />
                    }
                </div>
                <RowCells data={d}
                    columns={columns} 
                    classes={classes} 
                />
                { d.rowActions }
            </div>
    )   
}

export default Rows